import $ from 'jquery';
// --- Hover everything in a box ---
$('a.box-title, a.box-title2, .more, .more2, .more4 .box-inner').hover(function () {
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4, .box-inner').addClass('hover');
}, function () {
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4, .box-inner').removeClass('hover');
});
